import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import "./PublicLeaderboard.css";

const Leaderboard = () => {
    useEffect(() => {
        const navbar = document.querySelector("header, .navbar");
        const footer = document.querySelector("footer");
      
       
        if (navbar) navbar.style.display = "none";
        if (footer) footer.style.display = "none";
      
        return () => {
          // 🔥 மீண்டும் restore
          if (navbar) navbar.style.display = "";
          if (footer) footer.style.display = "";
        };
      }, []);
      

  const { token } = useParams();

  const [loading, setLoading] = useState(true);

  const [expired, setExpired] = useState(false);

  const [activeTab, setActiveTab] = useState("visual");

  const [updatedAt, setUpdatedAt] = useState("");

  const [visualLeaderboard, setVisualLeaderboard] = useState([]);

  const [reactionLeaderboard, setReactionLeaderboard] = useState([]);

  const [visualUserRank, setVisualUserRank] = useState(null);

  const [reactionUserRank, setReactionUserRank] = useState(null);

  const email =
    localStorage.getItem("rg_email") || "";

  /* ================= TOKEN VALIDATION ================= */

  const validateToken = async () => {

    try {

      await axios.get(

        `/api/leaderboard/${token}`

      );

      return true;

    }

    catch (error) {

      return false;

    }

  };

  /* ================= VISUAL ACUITY ================= */

  const fetchVisualLeaderboard = async () => {

    try {

      const res = await axios.get(

        `/api/leaderboard-free-visual-acuity?email=${email}`

      );

      setVisualLeaderboard(

        res.data.leaderboard || []

      );

      setVisualUserRank(

        res.data.userRank || null

      );

    }

    catch (error) {

      console.error(

        "Visual Leaderboard Error",

        error

      );

    }

  };

  /* ================= REACTION SPEED ================= */

  const fetchReactionLeaderboard = async () => {

    try {

      const res = await axios.get(

        `/api/webinar-leaderboard?email=${email}`

      );

      setReactionLeaderboard(

        res.data.leaderboard || []

      );

      setReactionUserRank(

        res.data.userRank || null

      );

    }

    catch (error) {

      console.error(

        "Reaction Leaderboard Error",

        error

      );

    }

  };

  /* ================= UPDATED DATE ================= */

  const updateDate = () => {

    const now = new Date();

    setUpdatedAt(

      now.toLocaleDateString("en-IN", {

        day: "2-digit",

        month: "short",

        year: "numeric"

      })

    );

  };

  /* ================= INITIAL LOAD ================= */

  useEffect(() => {

    const loadPage = async () => {

      setLoading(true);

      const valid = await validateToken();

      if (!valid) {

        setExpired(true);

        setLoading(false);

        return;

      }

      updateDate();

      await Promise.all([

        fetchVisualLeaderboard(),

        fetchReactionLeaderboard()

      ]);

      setLoading(false);

    };

    loadPage();

  }, []);

  /* ================= CURRENT TAB DATA ================= */

  const leaderboard =

    activeTab === "visual"

      ? visualLeaderboard

      : reactionLeaderboard;

  const userRank =

    activeTab === "visual"

      ? visualUserRank

      : reactionUserRank;
        /* ================= LOADING ================= */

  if (loading) {

    return (

      <div className="leaderboard-loading">

        <div className="leaderboard-spinner"></div>

        <h2>Loading Leaderboard...</h2>

      </div>

    );

  }

  /* ================= LINK EXPIRED ================= */

  if (expired) {

    return (

      <div className="leaderboard-expired">

        <h1>

          Link Expired

        </h1>

        <p>

          This leaderboard link is no longer active.

        </p>

      </div>

    );

  }

  /* ================= PAGE ================= */

  return (

    <div className="leaderboard-page">

      <div className="leaderboard-layout">

      <div className="leaderboard-container">

        {/* Header */}

        <div className="leaderboard-header">

          <h1>

            🏆 ForgeYourPeak Leaderboard

          </h1>

          <p>

            Compare your performance with athletes worldwide.

          </p>

        </div>

        {/* Top Bar */}

        <div className="leaderboard-topbar">

          <div className="live-status">

            <span className="live-dot"></span>

            Live Rankings

          </div>

          <div className="updated-date">

            Updated

            {updatedAt}

          </div>

        </div>

        {/* Tabs */}

        <div className="leaderboard-tabs">

          <button

            className={
              activeTab === "visual"
                ? "active"
                : ""
            }

            onClick={() =>
              setActiveTab("visual")
            }

          >

            👁 Visual Acuity

          </button>

          <button

            className={
              activeTab === "reaction"
                ? "active"
                : ""
            }

            onClick={() =>
              setActiveTab("reaction")
            }

          >

            ⚡ Reaction Speed

          </button>

        </div>

        {/* Top 3 */}

        <div className="top-three-card">

          <h2>

            Top Performers

          </h2>

          <table>

            <thead>

              <tr>

                <th>Rank</th>

                <th>Name</th>

                <th>

                  {activeTab === "visual"

                    ? "Vision"

                    : "Reaction"}

                </th>

              </tr>

            </thead>

            <tbody>

              {leaderboard.map((player) => (

                <tr key={player.email}>

                  <td>

                    {player.rank === 1 && "🥇"}

                    {player.rank === 2 && "🥈"}

                    {player.rank === 3 && "🥉"}
                    {player.rank > 3 && player.rank}


                  </td>

                  <td>

                    {player.name}

                  </td>

                  <td>

                    {activeTab === "visual"

                      ? player.acuity

                      : `${Math.round(
                          player.bestReaction * 1000
                        )} ms`}

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* Your Rank */}

        

      </div>

      {/* ================= RIGHT PANEL — METRIC LECTURE ================= */}

      <div className="lecture-container">

        <div className="lecture-card">

          <div className="lecture-badge">
            🎧 Metric Lecture
          </div>

          {/* ================= VISUAL ACUITY ================= */}
          {activeTab === "visual" && (
            <>
              <h3>Why Visual Acuity matters</h3>

              <p className="lecture-text">
                In sport, your eyes are the entry point for timing.
                Better acuity helps you pick up fine details earlier —
                seam/spin, body cues, and ball release — so your brain
                gets extra milliseconds to decide and move.
              </p>

              <audio controls className="audio-player">
                <source src="/audio/Visual_Acuity.mp3" type="audio/mpeg" />
              </audio>

              <div className="visual-card">

                <h4>
                  Visual Acuity → Earlier Pickup → Better Timing
                </h4>

                <p className="visual-sub">
                  Sharper resolution buys you decision time in fast sports.
                </p>

                <div className="flow">

                  <div className="flow-box blue">
                    Sharper Detail
                    <span>Seam • Spin • Release</span>
                  </div>

                  <div className="flow-box gray">
                    Earlier Processing
                    <span>More time to decide</span>
                  </div>

                  <div className="flow-box red">
                    Cleaner Action
                    <span>Better timing & control</span>
                  </div>

                </div>

              </div>
            </>
          )}

          {/* ================= REACTION SPEED ================= */}
          {activeTab === "reaction" && (
            <>
              <h3>Why Reaction Speed matters</h3>

              <p className="lecture-text">
                Reaction speed determines how fast your brain processes
                visual signals and converts them into action.
                Faster reactions help athletes respond instantly
                to unpredictable situations in sport.
              </p>

              <audio controls className="audio-player">
                <source src="/audio/Reaction_Speed.mp3" type="audio/mpeg" />
              </audio>

              <div className="visual-card">

                <h4>
                  Reaction Speed → Faster Decision → Faster Movement
                </h4>

                <p className="visual-sub">
                  Quick brain processing improves response time.
                </p>

                <div className="flow">

                  <div className="flow-box blue">
                    Visual Signal
                    <span>Ball / stimulus appears</span>
                  </div>

                  <div className="flow-box gray">
                    Brain Processing
                    <span>Recognize & decide</span>
                  </div>

                  <div className="flow-box red">
                    Physical Response
                    <span>Move / react instantly</span>
                  </div>

                </div>

              </div>
            </>
          )}

        </div>

      </div>

      </div>

    </div>

  );

};

export default Leaderboard;